import { gql } from "@apollo/client";

const instStopsGQL = gql`
  query($inst_id: String!) {
    institutions(instID: $inst_id) {
      inst_id
      locations {
        locId: loc_id
        status
        tours {
          tourid
          status
        }
      }
    }
  }
`;

export default instStopsGQL;
